import React from "react"
import { auditShape } from "utils/propTypeShapes"
import FormSubmissionLink from "../FormSubmissionLink"

const RelatedFormSubmissionCreatedAuditItemDetails = ({ audit }) => {
  const { relatedFormSubmissionSlug } = audit

  return (
    <div>
      Added <FormSubmissionLink formSubmissionSlug={relatedFormSubmissionSlug} /> as a related form submission.
    </div>
  )
}

RelatedFormSubmissionCreatedAuditItemDetails.propTypes = {
  audit: auditShape.isRequired,
}

export default RelatedFormSubmissionCreatedAuditItemDetails
